import React from 'react';

import {translate} from 'iss/strings';
import {cancelEvent} from 'iss/service/EvaluationEventService';
import {runBatchOps} from 'iss/utils/batchOps';
import {TextArea} from 'iss/widgets/Forms';
import {LateEventsList} from 'iss/widgets/LateEventsList';
import {EventCancelReasonSelector} from 'iss/widgets/Selectors';
import {ModalForm} from 'iss/widgets/batchOps/ModalForm';
import {listFailuresWithMessage} from 'iss/widgets/batchOps/question/BatchOpFailure';
import validators from 'iss/widgets/form/validation/validators';

const cancelEvents = {
    id: "cancelEvents",
    title: "lateEventsOperations.cancelEvents.title",
    progressMessage: "lateEventsOperations.cancelEvents.progressMessage",
    components: {
      settings: ({operationTargets, onCancel, startOperation}) =>
      <ModalForm proceedText={translate('lateEventsOperations.cancelEvents.proceed')}
        onSubmit={(formData) => startOperation(cancelLateEvents(operationTargets, formData))}
        onCancel={onCancel}>
        <p>
          {translate('lateEventsOperations.cancelEvents.confirmMessage', {count: operationTargets.length})}
        </p>
        <EventCancelReasonSelector label="lateEventsOperations.cancelEvents.cancellingReason" valuePath="cancellingReason" validate={validators.chooseOne} id="cancelEvent" />
        <TextArea label="lateEventsOperations.cancelEvents.cancellingReasonDescription" valuePath="description" />
        <LateEventsList compact={true} events={operationTargets} />
      </ModalForm>,
      success: <p>{translate("lateEventsOperations.cancelEvents.success")}</p>,
      failure: listFailuresWithMessage("lateEventsOperations.cancelEvents.failure")
    },
};

function cancelLateEvents(targets, {description, cancellingReason}) {
  const ops = targets.map((target) => (
    {operation: cancelEvent(target.id, {reason: cancellingReason, description}),
    question: target
    }));
  return runBatchOps(ops);
}

export default cancelEvents;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/lateEvents/cancelEvents.jsx